import { combineReducers, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { appTourReducer } from './reducers/appTourReducers';
import { betReducer } from './reducers/betReducers';
import { casinoReducer } from './reducers/casinoReducers';
import { customizationReducer } from './reducers/customizationReducers';
import { dialogReducer } from './reducers/dialogReducers';
import { iframeReducer } from './reducers/iframeReducers';
import { loginReducer } from './reducers/loginReducers';
import { navigationReducer } from './reducers/navigationReducers';
import { signupReducer } from './reducers/signupReducers';
import { sportsbookEventsReducer } from './reducers/sportsbookEventsReducer';
import { sportsbookReducer } from './reducers/sportsbookReducers';
import { ticketReducer } from './reducers/ticketReducers';
import { userDataReducer } from './reducers/userDataReducers';
import { walletReducer } from './reducers/walletReducers';
import { AppTourState } from './types/appTourTypes';
import { BetState } from './types/betTypes';
import { CasinoState } from './types/casinoTypes';
import { CustomizationState } from './types/customizationTypes';
import { DialogState } from './types/dialogTypes';
import { IframeState } from './types/iframeTypes';
import { LoginState } from './types/loginTypes';
import { NavigationState } from './types/navigationTypes';
import { SignupState } from './types/signupTypes';
import { SportsbookEventsState } from './types/sportsbookEventsType';
import { SportsbookState } from './types/sportsbookTypes';
import { TicketState } from './types/ticketTypes';
import { UserDataState } from './types/userDataTypes';
import { WalletState } from './types/walletTypes';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export interface TStore {
  bets: BetState;
  casino: CasinoState;
  customization: CustomizationState;
  dialogs: DialogState;
  iframe: IframeState;
  login: LoginState;
  navigation: NavigationState;
  signup: SignupState;
  sportsbook: SportsbookState;
  userData: UserDataState;
  tickets: TicketState;
  wallet: WalletState;
  sportsbookEvents: SportsbookEventsState;
  appTour: AppTourState;
}

const betsPersistConfig = {
  storage,
  key: 'bets',
  whitelist: ['pendingBets'],
};

const ticketsPersistConfig = {
  storage,
  key: 'tickets',
  whitelist: ['pendingTickets'],
};

const loginPersistConfig = {
  storage,
  key: 'login',
  whitelist: ['isFromApp'],
};

const rootReducer = combineReducers({
  bets: persistReducer(betsPersistConfig, betReducer),
  casino: casinoReducer,
  customization: customizationReducer,
  dialogs: dialogReducer,
  iframe: iframeReducer,
  login: persistReducer(loginPersistConfig, loginReducer),
  navigation: navigationReducer,
  signup: signupReducer,
  sportsbook: sportsbookReducer,
  userData: userDataReducer,
  tickets: persistReducer(ticketsPersistConfig, ticketReducer),
  wallet: walletReducer,
  sportsbookEvents: sportsbookEventsReducer,
  appTour: appTourReducer,
});

const hideDevToolsReduxStore = true;

const composeEnhancers = hideDevToolsReduxStore ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(rootReducer, composeEnhancers());

export const persistor = persistStore(store);
